import dayjs, { Dayjs } from "dayjs"
import TenkoTimingButton from "./TenkoTimingButton"
import { T点呼区分, e点呼区分 } from "../../../../constant/enum/unko"
import { TTenkoDetailInfoGetRes } from "../../../../service/truckcontrol/tenko/TTenko"
import Check from "./Check"

const TenkoTimingSelectCell = ({
  点呼区分コード,
  点呼明細List,
  move点呼場所,
  日付,
  点呼回数,
}: {
  日付: Dayjs
  点呼区分コード: T点呼区分
  点呼明細List: TTenkoDetailInfoGetRes[] | undefined
  点呼回数: number
  move点呼場所: (
    点呼明細: TTenkoDetailInfoGetRes | undefined,
    点呼区分コード: T点呼区分,
    日付: Dayjs,
    点呼回数: number
  ) => () => unknown
}) => {
  const 点呼明細 = 点呼明細List?.find(
    (d) =>
      dayjs(d.点呼日).isSame(日付, "d") &&
      d.点呼区分コード === 点呼区分コード &&
      d.点呼回数 === 点呼回数
  )
  let タイトル = ""

  switch (点呼区分コード) {
    case e点呼区分.始業点呼:
      タイトル = "始業"
      break
    case e点呼区分.中間点呼１:
      タイトル = "中間"
      break
    case e点呼区分.終業点呼:
      タイトル = "終業"
      break
    default:
      break
  }

  return (
    <TenkoTimingButton
      backGroundColor={点呼明細 != null ? "#e9f7ff" : undefined}
      onTouchStartEventHandler={
        点呼明細 == null
          ? move点呼場所(点呼明細, 点呼区分コード, 日付, 点呼回数)
          : () => {}
      }>
      <div
        style={{
          width: "100%",
          margin: "auto",
          textAlign: "center",
        }}>
        <div>
          <span>{タイトル + `${点呼回数 !== 1 ? 点呼回数 : ""}`}</span>
        </div>
        {点呼明細 != null && (
          <div>
            <div
              style={{
                width: "100%",
                margin: "auto",
                textAlign: "center",
              }}
              key={点呼明細.点呼記録明細ID}>
              {dayjs(
                dayjs(点呼明細.点呼時刻).add(
                  parseInt(点呼明細.点呼時刻 ?? "0"),
                  "ms"
                )
              ).format("HH:mm")}
            </div>
            <Check />
          </div>
        )}
      </div>
    </TenkoTimingButton>
  )
}

export default TenkoTimingSelectCell
